import { useTheme as StyledComponentsUseTheme } from 'styled-components'
import { Theme as MuiTheme } from '@mui/material/styles'

const useTheme = StyledComponentsUseTheme as () => MuiTheme

export default useTheme
